import React from 'react';
import { Lock, Zap, ShieldCheck, Download } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
interface PurchaseButtonProps {
  text: string;
  className?: string;
  variant?: 'light' | 'dark';
  hideMicrocopy?: boolean;
  href?: string;
}
export function PurchaseButton({
  text,
  className = '',
  variant = 'light',
  hideMicrocopy = false,
  href
}: PurchaseButtonProps) {
  const microcopyColor = variant === 'dark' ? 'text-cream/80' : 'text-ink/70';
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      // Default CTA → scroll to final offer section
      e.preventDefault();
      document.getElementById('checkout')?.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // Final CTA going to Shopify → fire AddToCart
      trackAddToCart();
    }
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-276">
      <a href={href || '#checkout'} onClick={handleClick} className="group relative block w-full max-w-md text-center bg-gradient-to-br from-accent via-accent to-primary text-white font-sans font-extrabold text-base md:text-lg py-4 md:py-5 px-6 rounded-full shadow-[0_8px_0_#3A1D2C,0_12px_25px_rgba(92,46,70,0.45)] hover:-translate-y-1 hover:shadow-[0_10px_0_#3A1D2C,0_16px_30px_rgba(92,46,70,0.55)] active:translate-y-2 active:shadow-[0_2px_0_#3A1D2C,0_4px_10px_rgba(92,46,70,0.4)] transition-all duration-200 tracking-wide ring-2 ring-white/20" data-id="element-277">
        <span className="relative z-10 drop-shadow-sm" data-id="element-278">{text} →</span>
        <span className="absolute inset-0 rounded-full bg-gradient-to-t from-transparent via-white/0 to-white/15 pointer-events-none" data-id="element-279"></span>
      </a>
      {!hideMicrocopy && <div className={`mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs font-medium ${microcopyColor}`} data-id="element-280">
          <span className="flex items-center gap-1" data-id="element-281">
            <Lock size={11} data-id="element-282" /> Pago seguro
          </span>
          <span className="opacity-40" data-id="element-283">·</span>
          <span className="flex items-center gap-1" data-id="element-284">
            <Zap size={11} data-id="element-285" /> Acceso inmediato
          </span>
          <span className="opacity-40" data-id="element-286">·</span>
          <span className="flex items-center gap-1" data-id="element-287">
            <ShieldCheck size={11} data-id="element-288" /> Garantía 7 días
          </span>
          <span className="opacity-40 hidden sm:inline" data-id="element-289">·</span>
          <span className="hidden sm:flex items-center gap-1" data-id="element-290">
            <Download size={11} data-id="element-291" /> Descarga digital
          </span>
        </div>}
    </div>;
}